import { h } from "@stencil/core";
import { applicationsLaser, applicationsOptics, applicationsWelding } from "../../../api/publicApi/createCase/applications";
import { TranslationKey } from "../../../utils/loadTranslations";

export const ApplicationSelect = ({ t, formStore, prefillData }) => (
    <ux-select
        required
        label={t("field.application.label")}
        data-validation-required--msg={t("validation.requiredField")}
        name="application"
        onUxChange={(event) => {
            formStore.state.selectedApplication = Number(event.detail.value);
        }}
    >
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsLaser.map((application) => (
            <option value={application.id} selected={prefillData?.applicationTopicIds?.includes(application.id)}>
                {t(`application.${application.labelKey}` as TranslationKey)}
            </option>
        ))}
    </ux-select>
);

export const ApplicationOpticsSelect = ({ t, prefillData }) => (
    <ux-select label={t("field.optics.label")} name="optics">
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsOptics.map((application) => (
            <option value={application.id} selected={prefillData?.applicationTopicIds?.includes(application.id)}>
                {t(`application.${application.labelKey}` as TranslationKey)}
            </option>
        ))}
    </ux-select>
);

export const ApplicationIssueSelect = ({ t, prefillData }) => (
    <ux-select label={t("field.applicationIssue.label")} name="applicationIssue">
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsWelding.map((application) => (
            <option value={application.id} selected={prefillData?.applicationTopicIds?.includes(application.id)}>
                {t(`application.${application.labelKey}` as TranslationKey)}
            </option>
        ))}
    </ux-select>
);
